import React, { useState, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import EmployeeSidebar from "../components/EmployeeSidebar";
import Header from "../components/Header";
import EmployeeProvider from "context/EmployeeContext";

const EmployeePortalLayout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(() => window.innerWidth > 768);
    const { pathname } = useLocation();

    // Close on route change on mobile
    useEffect(() => {
        if (window.innerWidth <= 768) setSidebarOpen(false);
    }, [pathname]);

    // Close if window resizes to mobile
    useEffect(() => {
        const handler = () => { if (window.innerWidth <= 768) setSidebarOpen(false); };
        window.addEventListener('resize', handler);
        return () => window.removeEventListener('resize', handler);
    }, []);

    return (
        <EmployeeProvider>
            {sidebarOpen && (
                <div className="mobile-sidebar-backdrop" onClick={() => setSidebarOpen(false)} style={{ display: 'none' }} />
            )}
            <div style={{ display: 'flex', minHeight: '100vh', background: '#F8F9FA', fontFamily: '"Poppins", serif' }}>
                <EmployeeSidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column', overflow: 'auto', minWidth: 0 }}>
                    <Header onMenuClick={() => setSidebarOpen(o => !o)} />
                    <div style={{ flex: 1, overflow: 'auto' }}>
                        <Outlet />
                    </div>
                </div>
            </div>
            <button className="mobile-hamburger" onClick={() => setSidebarOpen(o => !o)} aria-label="Toggle menu">
                {sidebarOpen ? '✕' : '☰'}
            </button>
        </EmployeeProvider>
    );
};

export default EmployeePortalLayout;
